"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var ArrowUp_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowUp"));
var ArrowDown_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowDown"));
var AppRow_1 = __importDefault(require("./AppRow"));
var appShape_1 = __importDefault(require("../../appShape"));
var Section_styles_1 = __importDefault(require("./Section.styles"));
function Section(_a) {
    var apps = _a.apps, title = _a.title;
    var _b = react_1.default.useState(false), isCollapsed = _b[0], setIsCollapsed = _b[1]; // TODO: get from some local storage or other method
    var i18n = useI18n_1.default();
    function toggleIsCollapsed() {
        setIsCollapsed(function (prevIsCollapsed) { return !prevIsCollapsed; });
    }
    return (react_1.default.createElement(Section_styles_1.default, { ariaText: title + " " + i18n.t('global_navigation.section'), "data-sri-anchor": "app-switcher-section", isCollapsed: isCollapsed, label: title, onClick: toggleIsCollapsed, iconAlign: "right", iconCollapse: react_1.default.createElement(ArrowDown_1.default, null), iconExpand: react_1.default.createElement(ArrowUp_1.default, null), "data-testid": "appSection" }, apps.map(function (app) { return (react_1.default.createElement(AppRow_1.default, { app: app, key: app.title }, app.title)); })));
}
Section.propTypes = {
    apps: prop_types_1.default.arrayOf(prop_types_1.default.shape(appShape_1.default)).isRequired,
    title: prop_types_1.default.string.isRequired,
};
exports.default = Section;
//# sourceMappingURL=Section.js.map